/**
* 告警邮箱新建弹框组件
*
* @author By AICode
* @date 2026-03-19
*/
<template>
  <a-modal
    :title="mode === 'edit' ? '编辑' : '新建'"
    :visible="visible"
    :confirm-loading="loading"
    ok-text="确认"
    cancel-text="取消"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :form="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
      <a-form-item label="License申请人">
        <a-input
          v-decorator="[
            'applicantName',
            {
              rules: [
                { required: true, message: 'License申请人不能为空' },
                { max: 64, message: 'License申请人最多64个字符' },
              ],
            },
          ]"
          placeholder="请输入，需和OA中ONE License申请单中该字段一致"
        />
      </a-form-item>
      <a-form-item label="关联邮箱">
        <a-textarea
          v-decorator="[
            'emailList',
            {
              rules: [
                { required: true, message: '关联邮箱不能为空' },
                { max: 2000, message: '关联邮箱最多2000个字符' },
                { validator: validateBonreeEmails },
              ],
            },
          ]"
          placeholder="多个邮箱用英文;连接，仅支持@bonree.com后缀邮箱"
          :auto-size="{ minRows: 3, maxRows: 6 }"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { Modal, Form, Input } from 'ant-design-vue'
import { validateBonreeEmailsValue, normalizeEmailList } from './validators'

export default {
  name: 'AddEmail',
  components: {
    'a-modal': Modal,
    'a-form': Form,
    'a-form-item': Form.Item,
    'a-input': Input,
    'a-textarea': Input.TextArea,
  },
  props: {
    visible: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    mode: { type: String, default: 'create' },
    initialValues: {
      type: Object,
      default: () => ({
        applicantName: '',
        emailList: [],
      }),
    },
  },
  beforeCreate() {
    this.form = this.$form.createForm(this)
  },
  watch: {
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          this.form.setFieldsValue({
            applicantName: this.initialValues.applicantName || '',
            emailList: Array.isArray(this.initialValues.emailList) ? this.initialValues.emailList.join(';') : '',
          })
        })
      }
    },
  },
  methods: {
    validateBonreeEmails(rule, value, callback) {
      const error = validateBonreeEmailsValue(value)
      callback(error)
    },

    handleOk() {
      this.form.validateFields((err, values) => {
        if (err) return
        const emailList = normalizeEmailList(values.emailList)
        this.$emit('ok', {
          applicantName: values.applicantName.trim(),
          emailList,
        })
      })
    },

    handleCancel() {
      this.$emit('cancel')
      this.form.resetFields()
    },
  },
}
</script>
